var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.567,
    height: 9.819,
    viewBox: "0 0 12.567 9.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exchange-alt",
    "data-name": "Icon awesome-exchange-alt",
    d: "M0,6.685V6.293A.589.589,0,0,1,.589,5.7H9.425V4.525a.59.59,0,0,1,1.006-.417l1.964,1.964a.589.589,0,0,1,0,.833L10.431,8.869a.589.589,0,0,1-1.006-.417V7.274H.589A.589.589,0,0,1,0,6.685Zm11.978,3.731H3.142V9.238a.59.59,0,0,0-1.006-.417L.173,10.785a.589.589,0,0,0,0,.833l1.964,1.964a.589.589,0,0,0,1.006-.417V11.987h8.836a.589.589,0,0,0,.589-.589v-.393A.589.589,0,0,0,11.978,10.416Z",
    transform: "translate(0 -3.936)",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChange);
export default __webpack_public_path__ + "static/media/IconChange.046d9500df809ba4a74764ebd348d990.svg";
export { ForwardRef as ReactComponent };